import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var Layer = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("path", { d: "M20.466 7.647l-7.294-5.273a2.019 2.019 0 0 0-2.348.003L3.532 7.649c-.516.375-.824.98-.824 1.619s.308 1.243.825 1.619l7.295 5.274a2.013 2.013 0 0 0 2.348-.003l7.291-5.271.001-.001a2.002 2.002 0 0 0-.002-3.239z", key: "k0" }),
        React.createElement("path", { d: "M11.936 19.766l-7.229-5.204-1.694 1.246 7.758 5.583a2.019 2.019 0 0 0 2.346-.002l7.873-5.665-1.717-1.233-7.337 5.275z", key: "k1" })));
});
Layer.displayName = 'Layer';
export var LayerDimensions = { height: 24, width: 24 };
